export default __webpack_public_path__ + "static/media/paymentDone.7395192c.mp3";